import { useEffect, useRef, useState } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import CommonTable from "../component/CommonTable";
import { useHandleError } from "../hooks/useHandleError";
import MessageToster from "../component/MessageToster";
import { getApiHeaders } from "../utils/helpers";
import axios from "axios";
import { BASE_URL } from "../api";
import Loader from "../component/Loader";
import useIbStatus from "../hooks/useIbStatus";
import ExportButton from "../component/ExportButton";
import { exportToExcel } from "../utils/exportData";
import MobileFilter from "../component/MobileFilter";

export default function Report() {
  const handleError = useHandleError();
  const [ibSubReport, setIbSubReport] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const mid = sessionStorage.getItem("mid");
  // const mid = 25; // -- testing
  const [kycFilter, setKycFilter] = useState("All");
  const [ibStatusFilter, setIbStatusFilter] = useState("All");
  const [traderFilter, setTraderFilter] = useState("Trader/Sub IB");
  const [searchTerm, setSearchTerm] = useState("");

  const {
    ibStatus,
    ibLoading,
    isActive,
    isPending,
    isNotApplied
  } = useIbStatus();

  const isPageLoading = ibLoading || loading;

  const getIbSubReportData = async () => {
    setLoading(true);
    try {
      const inputBody = {
        mid: Number(mid),
        // mid: Number(25)
      };
      const res = await axios.get(
        `${BASE_URL}/IB/ib_sub_report_overview`,
        { headers: getApiHeaders() }
      );

      if (res.data.code === 200) {
        // setIbSubReport(res.data.data);
        const allReportData = res.data.data || [];
        setIbSubReport(allReportData);

        setFilteredData(allReportData);
      } else {
        MessageToster("error", res.data.message || "No data found.");
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isActive) {
      getIbSubReportData();
    }
  }, [isActive]);

  const handleSearch = () => {
    if (ibSubReport?.length > 0) {
      // const filteredData =
      //   kycFilter === "All"
      //     ? ibSubReport
      //     : ibSubReport.filter(
      //       (item) => item.kycstatus?.toLowerCase() === kycFilter.toLowerCase()
      //     );

      let nextFilteredData = [...ibSubReport];

      if (kycFilter !== "All") {
        nextFilteredData = nextFilteredData.filter(
          (item) => item.kycstatus?.toLowerCase() === kycFilter.toLowerCase()
        );
      }

      if (ibStatusFilter !== "All") {
        nextFilteredData = nextFilteredData.filter(
          (item) =>
            item.ibstatus?.toLowerCase() === ibStatusFilter.toLocaleLowerCase()
        );
      }

      if (searchTerm) {
        const query = searchTerm.toLowerCase();
        nextFilteredData = nextFilteredData.filter((item) =>
          String(item.fullname || "").toLowerCase().includes(query) ||
          String(item.email || "").toLowerCase().includes(query) ||
          String(item.level || "").toLowerCase().includes(query) ||
          String(item.client_id || "").toLowerCase().includes(query) ||
          String(item.account_number || "").toLowerCase().includes(query) ||
          String(item.ftd || "").toLowerCase().includes(query)
        );
      }

      setFilteredData(nextFilteredData);
    }
  };

  const clearFilters = () => {
    setKycFilter("All");
    setIbStatusFilter("All");
    setTraderFilter("Trader/Sub IB");
    setSearchTerm("");
    setFilteredData(ibSubReport || []);
  };

  // useEffect(() => {
  //   if (ibSubReport?.length > 0) {
  //     const rows = ibSubReport.map(item => [
  //       item.fullname,
  //       item.email || "-",
  //       item.level,
  //       item.client_id || "-",
  //       mid,
  //       item.kycstatus,
  //       item.account_number,
  //       item.ftd,
  //       item.ibstatus || "-"
  //     ]);

  //     displayButtons(tableRef, rows);
  //   }
  // }, [ibSubReport, mid]);

  // useEffect(() => {
  //   displayButtons(tableRef)
  // }, [])

  return (
    <>
      <div id="layout-wrapper">
        {isPageLoading && <Loader />}
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-sm-0">
                      Trade/Sub IB Analytics Report
                    </h2>
                  </div>
                </div>
              </div>
              {/* end page title */}
              {isActive && (
                <>
                  <div className="row">
                    <div className="col-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex flex-wrap align-items-end gap-2 mb-4 desktop-filter-row">
                            <div>
                              <label htmlFor="">Trader/Sub IB</label>
                              <select
                                className="form-select"
                                value={traderFilter}
                                onChange={(e) => setTraderFilter(e.target.value)}
                              >
                                <option value="Trader/Sub IB">Trader/Sub IB</option>
                                <option value="In">In</option>
                                <option value="Out">Out</option>
                              </select>
                            </div>
                            <div>
                              <label htmlFor="">Kyc</label>
                              <select
                                className="form-select"
                                value={kycFilter}
                                onChange={(e) => setKycFilter(e.target.value)}
                              >
                                <option>All</option>
                                <option>Approve</option>
                                <option>Pending</option>
                                <option>Reject</option>
                              </select>
                            </div>
                            {/* <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-3">
                          <label htmlFor="">Live A/C</label>
                          <select className="form-select">
                            <option>All</option>
                            <option>Large select</option>
                            <option>Small select</option>
                          </select>
                        </div> */}
                            {/* <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-3">
                          <label htmlFor="">FTD</label>
                          <select className="form-select">
                            <option>All</option>
                            <option>Large select</option>
                            <option>Small select</option>
                          </select>
                        </div> */}
                            <div>
                              <label htmlFor="">IB Status</label>
                              <select
                                className="form-select"
                                value={ibStatusFilter}
                                onChange={(e) => setIbStatusFilter(e.target.value)}
                              >
                                <option>All</option>
                                <option>Pending</option>
                                <option>Active</option>
                                <option>Not applied</option>
                              </select>
                            </div>
                            <div>
                              <label htmlFor="">Search</label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                              />
                            </div>
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary waves-effect waves-light"
                                onClick={handleSearch}
                                title="Search"
                              >
                                <span>Search</span>
                              </button>
                            </div>
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary waves-effect waves-light"
                                onClick={clearFilters}
                                disabled={kycFilter === "All" && ibStatusFilter === "All" && traderFilter === "Trader/Sub IB" && !searchTerm}
                                title="Clear"
                              >
                                <span>Clear</span>
                              </button>
                            </div>
                            <div className="ms-auto">
                              <ExportButton
                                disabled={!filteredData || filteredData.length === 0}
                                onClick={() => exportToExcel(filteredData, "Reports", "default")}
                              />
                            </div>
                          </div>

                          <MobileFilter
                            title="History"
                            onExport={() => exportToExcel(filteredData, "Reports", "default")}
                            exportDisabled={!filteredData || filteredData.length === 0}
                          >
                            <div>
                              <label htmlFor="">Trader/Sub IB</label>
                              <select
                                className="form-select"
                                value={traderFilter}
                                onChange={(e) => setTraderFilter(e.target.value)}
                              >
                                <option value="Trader/Sub IB">Trader/Sub IB</option>
                                <option value="In">In</option>
                                <option value="Out">Out</option>
                              </select>
                            </div>
                            <div>
                              <label htmlFor="">Kyc</label>
                              <select
                                className="form-select"
                                value={kycFilter}
                                onChange={(e) => setKycFilter(e.target.value)}
                              >
                                <option>All</option>
                                <option>Approve</option>
                                <option>Pending</option>
                                <option>Reject</option>
                              </select>
                            </div>
                            <div>
                              <label htmlFor="">IB Status</label>
                              <select
                                className="form-select"
                                value={ibStatusFilter}
                                onChange={(e) => setIbStatusFilter(e.target.value)}
                              >
                                <option>All</option>
                                <option>Pending</option>
                                <option>Active</option>
                                <option>Not applied</option>
                              </select>
                            </div>
                            <div>
                              <label htmlFor="">Search</label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                              />
                            </div>
                            <div className="d-flex gap-2 mt-2">
                              <button
                                type="button"
                                className="btn btn-primary waves-effect waves-light flex-grow-1"
                                onClick={handleSearch}
                                data-bs-dismiss="offcanvas"
                                data-bs-target="#filterOffcanvasMobile"
                              >
                                Search
                              </button>
                              <button
                                type="button"
                                className="btn btn-light waves-effect waves-light border flex-grow-1"
                                onClick={clearFilters}
                                disabled={kycFilter === "All" && ibStatusFilter === "All" && traderFilter === "Trader/Sub IB" && !searchTerm}
                                data-bs-dismiss="offcanvas"
                                data-bs-target="#filterOffcanvasMobile"
                              >
                                Clear
                              </button>
                            </div>
                          </MobileFilter>
                          <div className="mb-3">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="gridCheck"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="gridCheck"
                              >
                                Include Child
                              </label>
                            </div>
                          </div>
                          <CommonTable
                            columns={[
                              { header: "Name", accessor: "fullname" },
                              { header: "Email", render: (row) => row.email || "-" },
                              { header: "Level", accessor: "level" },
                              { header: "Affiliate Code", render: (row) => row.client_id || "-" },
                              { header: "Kyc", render: (row) => row.kycstatus || "-" },
                              { header: "Live A/C", render: (row) => row.account_number || "-" },
                              { header: "FTD", accessor: "ftd" },
                              { header: "IB Status", render: (row) => row.ibstatus || "-" }
                            ]}
                            data={filteredData || []}
                            loading={loading}
                          />
                        </div>
                      </div>
                    </div>{" "}
                    {/* end col */}
                  </div>
                </>
              )}

              {isPending && (
                <>
                  <div className="row justify-content-center">
                    <div
                      className="alert alert-warning alert-dismissible fade show"
                      role="alert"
                      style={{
                        marginBottom: "1.5rem",
                      }}
                    >
                      <i className="mdi mdi-timer-sand-full me-2" />
                      Your IB Account application status is <strong>pending</strong>. Please
                      allow up to 24 hours for verification and approval.
                    </div>
                  </div>
                </>
              )}

              {isNotApplied && (
                <>
                  <div className="row justify-content-center">
                    <div
                      className="alert alert-warning alert-dismissible fade show"
                      role="alert"
                      style={{
                        marginBottom: "1.5rem",
                      }}
                    >
                      <i className="mdi mdi-timer-sand-full me-2" />
                      You have <strong>not applied</strong> for an IB Account yet.
                      Please submit your IB application to get started.
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* container-fluid */}
          </div>
          {/* End Page-content */}
          <Footer />
        </div>
      </div>
    </>
  );
}
